export enum SelectedFileType {
  Document,
  Image,
}
